const GeneralBucket = (state = {}, action) => {
    switch(action.type){
        case "SET_GENERAL_DATA":
            return {
                ...state,
                bucket: action.payload
            }
        default:
            return state
    }
}

export default GeneralBucket;